"use strict";

import onInitModulesInsScope from "./onInitModulesInScope";

/**
 * Toggles the can-scroll-start/can-scroll-end modifier classes used by the
 * fade/shadow hints in content-timetable.css. Needed as real JS state (rather
 * than a pure-CSS background trick) because the table's own row striping
 * (tbody tr:nth-child(even)) sits on top of any background layered behind it,
 * so the hint has to be a real overlay/shadow that only shows on whichever
 * edge still has columns hidden by the scroll container.
 *
 * can-scroll-end drives the white fade overlay on .content-timetable__train-wrap
 * (position: relative, never scrolls; .content-timetable__train-scroll — a
 * separate inner element — is the one with overflow-x: auto, so the overlay's
 * absolute positioning stays anchored to the outer, non-scrolling element
 * instead of scrolling away with the table). can-scroll-start instead drives
 * a box-shadow on the sticky .content-timetable__station column itself, since
 * that column now pins over the entire left edge. The same state is mirrored
 * onto the mobile-only arrow row (.content-timetable__scroll-hints) above the
 * wrap, which sits outside of it and so can't pick up the wrap's modifiers;
 * its two arrow buttons scroll the table and are disabled at either edge.
 */

const CAN_SCROLL_START_CLASS = 'content-timetable__train-wrap--can-scroll-start';
const CAN_SCROLL_END_CLASS = 'content-timetable__train-wrap--can-scroll-end';
const HINTS_CAN_SCROLL_START_CLASS = 'content-timetable__scroll-hints--can-scroll-start';
const HINTS_CAN_SCROLL_END_CLASS = 'content-timetable__scroll-hints--can-scroll-end';

function getHints(scroll) {
    return scroll.parentElement.parentElement.querySelector('.content-timetable__scroll-hints');
}

function updateShadows(scroll) {
    let wrap = scroll.parentElement;
    let hints = getHints(scroll);
    let maxScrollLeft = scroll.scrollWidth - scroll.clientWidth;
    let canScrollStart = scroll.scrollLeft > 1;
    let canScrollEnd = scroll.scrollLeft < maxScrollLeft - 1;

    wrap.classList.toggle(CAN_SCROLL_START_CLASS, canScrollStart);
    wrap.classList.toggle(CAN_SCROLL_END_CLASS, canScrollEnd);

    if (hints) {
        hints.classList.toggle(HINTS_CAN_SCROLL_START_CLASS, canScrollStart);
        hints.classList.toggle(HINTS_CAN_SCROLL_END_CLASS, canScrollEnd);
        hints.querySelector('.content-timetable__scroll-hint--start').disabled = !canScrollStart;
        hints.querySelector('.content-timetable__scroll-hint--end').disabled = !canScrollEnd;
    }
}

// Pages by the width of the time columns actually in view — the sticky
// station column covers the rest of clientWidth, so scrolling by the full
// clientWidth would skip columns that were never visible.
function scrollByPage(scroll, direction) {
    let station = scroll.querySelector('.content-timetable__station');
    let pageWidth = scroll.clientWidth - (station ? station.offsetWidth : 0);

    scroll.scrollBy({ left: direction * pageWidth, behavior: 'smooth' });
}

export function init() {
    onInitModulesInsScope(function initInScope($scope) {
        let scrolls = $scope.find('.content-timetable__train-scroll').toArray();

        if (!scrolls.length) {
            return;
        }

        scrolls.forEach(function (scroll) {
            updateShadows(scroll);
            scroll.addEventListener('scroll', function () {
                updateShadows(scroll);
            }, { passive: true });

            let hints = getHints(scroll);
            if (hints) {
                hints.querySelector('.content-timetable__scroll-hint--start').addEventListener('click', function () {
                    scrollByPage(scroll, -1);
                });
                hints.querySelector('.content-timetable__scroll-hint--end').addEventListener('click', function () {
                    scrollByPage(scroll, 1);
                });
            }
        });

        window.addEventListener('resize', function () {
            scrolls.forEach(updateShadows);
        });

        // Tab panes are display:none while inactive, so a scroll element's
        // scrollWidth/clientWidth can only be measured correctly once its
        // pane has actually become visible.
        $scope.find('.content-timetable__tabs').on('shown.bs.tab', function () {
            scrolls.forEach(updateShadows);
        });
    });
}
